const global = {
  black: '#1B1B1B',
};

export const lightTheme = {
  name: 'light',
  colors: {
    ...global,
    content: '#1B1B1B',
    muted: 'rgba(36,49,61,.4)',
    primary: '#16DAC1',
    background: '#FFFFFF',
    backgroundItem: 'transparent',
    defaultButton: '#FFFFFF',
    defaultButtonActive: 'rgba(57,76,96,.15)',
    input: undefined,
    inputStroke: '#D9D9D9',
    text: '#1B1B1B',
    stroke: '#D9D9D9',
    workspace: '#EBECF0',
    pill: 'rgba(64,87,109,.07)',
  },
  shadow: {
    hoverItem: '0px 4px 10px rgba(0, 0, 0, 0.10)',
  },
};

export const darkTheme = {
  name: 'dark',
  colors: {
    ...global,
    content: '#E4E4E4',
    muted: 'rgba(228,228,228,.4)',
    primary: '#13B9A4',
    background: '#1B1B1B',
    backgroundItem: '#434343',
    defaultButton: '#272727',
    defaultButtonActive: '#434343',
    input: '#151515',
    inputStroke: '#2A2A2A',
    text: '#E4E4E4',
    stroke: '#3F3F3F',
    workspace: '#282B2B',
    pill: 'rgba(160, 180, 200, 0.15)',
  },
  shadow: {
    hoverItem: undefined,
  },
};
